'use client';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { subscribeFn } from 'eco-design-micro/apis/subscribeFn';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';
import getLocal from 'eco-design-reliance/getLocal';
import EcoImg from 'eco-design/base/eco-img';
import EcoEmail from 'eco-design/elements/eco-email';
import './index.scss';

export const emailsTermsTranObj = {
    us: 'I agree to receive newsletters and marketing emails from EcoFlow. For details, please refer to the <a href="https://account.ecoflow.com/agreement/en-us/TermsOfUse.html" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
};

export default function Content({ id, data = {} }: ContentServerProps) {
    const { pc, h5, title, subTitle, emarsysType, isAgree = false } = data;
    const { locale = 'us' } = getLocal();
    const prefixCls = 'index-join-email';

    const submitSubscribeHandle1 = ({ email }: any, callback: any) => {
        submitSubscribe(email, callback);
        return true;
    };
    const submitSubscribe = async (email: string, callback: any) => {
        const cookieDataA = subscribeCookie({
            entry_name: 'subscriptionfloating',
            entry_position: 0,
        });
        const res = await subscribeFn(email, emarsysType || 'WEB_REGISTER', locale, cookieDataA);
        if (res?.code === '0') {
            callback('success');
        } else {
            callback('fail');
        }
        return true;
    };
    return (
        <GloLayout className={`editor-index-join-email`} id={id} data={data} floorName="index-join-email">
            <div className={`eco-content-v2 ${prefixCls}-send-container`}>
                <div className={`${prefixCls}-send`}>
                    <div className={`${prefixCls}-send-l`}>
                        <div className={`${prefixCls}-send-title`}>{title}</div>
                        <div className={`${prefixCls}-send-desc`}>{subTitle}</div>
                    </div>
                    <div className={`${prefixCls}-send-r`}>
                        <EcoEmail
                            contactListId={[]}
                            tipsObj={{
                                placeholder: locale === 'us' ? 'Email' : undefined,
                            }}
                            termsHtml={emailsTermsTranObj?.[locale as 'us'] || emailsTermsTranObj.us}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'click_subscribe',
                                button_name: 'Subscribe',
                                product_name: '',
                                module_name: title,
                            }}
                            defaultTermsCheck={isAgree}
                            key={`${isAgree}`}
                            onBeforeSendCallback={submitSubscribeHandle1}
                        />
                    </div>
                </div>
                <EcoImg className={`${prefixCls}-bg-img`} pc={pc} h5={h5} />
            </div>
        </GloLayout>
    );
}
